import {
  FETCH_TAXONOMY_REDIRECTS_ERROR,
  FETCH_TAXONOMY_REDIRECTS_REQUEST,
  FETCH_TAXONOMY_REDIRECTS_SUCCESS,
} from '../actions/tagRedirects';

export const initialState = {
  error: false,
  isReceived: false,
  mappings: {
    categoriesRules: {},
    filtersRules: {},
  },
};

export default function tagRedirects(state = initialState, action) {
  switch (action.type) {
    case FETCH_TAXONOMY_REDIRECTS_SUCCESS: {
      return {
        error: false,
        mappings: {
          ...initialState.mappings,
          ...action.data,
        },
        isReceived: true,
      };
    }
    case FETCH_TAXONOMY_REDIRECTS_ERROR: {
      return {
        ...initialState,
        error: action.error,
        isReceived: true,
      };
    }
    case FETCH_TAXONOMY_REDIRECTS_REQUEST:
    default:
      return state;
  }
}
